module.exports = __webpack_public_path__ + "static/media/Img_11.0e6e1d37.JPG";